export function decodeJwt<T>(token: string): T | null {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) {
      return null
    }

    const base64UrlDecode = (base64Url: string): string => {
      try {
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        const padding
          = base64.length % 4 === 0 ? '' : '='.repeat(4 - (base64.length % 4))
        base64 += padding
        return new TextDecoder().decode(
          Uint8Array.from(atob(base64), c => c.charCodeAt(0)),
        )
      }
      catch {
        return ''
      }
    }

    const payload = base64UrlDecode(parts[1])
    return payload ? JSON.parse(payload) : null
  }
  catch {
    return null
  }
}
